import React from "react";
import { Typography, Box } from '@mui/material';
import PickStatsHeader from "./PickStatsCardHeader";
import PickStatsStatBox from "./PickStatsStatBox";
import { useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import './PickStatsCardSingle.scss';

const PickStatsCardSingle = ({
    gameInfo,
    pickInfo,
    thisIntervalsName,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // Map the property names from gameInfo to what PickStatsCard expects
    const awayLogo = gameInfo?.awayTeamLogo;
    const homeLogo = gameInfo?.homeTeamLogo;
    const awayName = gameInfo?.awayTeamName;
    const homeName = gameInfo?.homeTeamName;
    const gameStatus = gameInfo?.status;
    const awayScore = gameInfo?.awayTeamScore;
    const homeScore = gameInfo?.homeTeamScore;
    const hasGameStarted = gameInfo?.hasGameStarted;
    const dateTime = new Date(gameInfo?.dateTime).toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    });

    // Map pickInfo properties
    const awaySpreadResult = pickInfo?.awayResult;
    const homeSpreadResult = pickInfo?.homeResult;
    const awaySpreadCount = pickInfo?.awayCount;
    const homeSpreadCount = pickInfo?.homeCount;
    const awaySpreadRecord = `${pickInfo?.awayWins}-${pickInfo?.awayLosses}-${pickInfo?.awayPushes}`;
    const homeSpreadRecord = `${pickInfo?.homeWins}-${pickInfo?.homeLosses}-${pickInfo?.homePushes}`;

    // Format for the closing spread
    const closingSpread = gameInfo?.homePointSpread ? 
        (gameInfo?.homePointSpread > 0 ? 
            `${awayName} (-${gameInfo?.homePointSpread})` : 
            gameInfo?.homePointSpread === 0 ? 
                `Pick` : 
                `${homeName} (${gameInfo?.homePointSpread})`) :
        'N/A';

    return (
        <Box className="super-pickem-pick-stats-single-card-container">
            <PickStatsHeader
                awayLogo={awayLogo}
                homeLogo={homeLogo}
                awayName={awayName}
                homeName={homeName}
                gameStatus={gameStatus}
                awayScore={awayScore}
                homeScore={homeScore}
            />
            <Box className="super-pickem-pick-stats-single-label-container">
                <Box className="super-pickem-pick-stats-single-label">
                    <Typography className="super-pickem-pick-stats-single-label">
                        ATS
                    </Typography>   
                </Box>
            </Box>
            <Box className="super-pickem-pick-stats-single-stat-boxes-main-container">
                <PickStatsStatBox 
                    pickType="spread"
                    hasGameStarted={hasGameStarted}
                    awayLogo={awayLogo}
                    homeLogo={homeLogo}
                    leftText={awayName}
                    rightText={homeName}
                    gameStatus={gameStatus}
                    leftCount={awaySpreadCount}
                    rightCount={homeSpreadCount}
                    leftResult={awaySpreadResult}
                    rightResult={homeSpreadResult}
                    leftRecord={awaySpreadRecord}
                    rightRecord={homeSpreadRecord}
                />
            </Box>

            <Box 
                className="super-pickem-pick-stats-single-card-footer"
                sx={{
                    height: isMobile ? '35px' : '45px',
                }}
            >
                {/* Left-Aligned Text (Date) */}
                <Box 
                    className="super-pickem-pick-stats-single-card-footer-text-container"
                    sx={{ justifyContent: 'flex-start' }}
                >
                    <Typography 
                        className="super-pickem-pick-stats-single-card-footer-text"
                        sx={{ textAlign: 'left' }}
                    >
                        {dateTime}
                    </Typography>
                </Box>

                {/* Right-Aligned Text (Spread) */}
                <Box  
                    className="super-pickem-pick-stats-single-card-footer-text-container"
                    sx={{ justifyContent: 'flex-end' }}
                >
                    <Typography
                        className="super-pickem-pick-stats-single-card-footer-text"
                        sx={{ textAlign: 'right' }}
                    >
                        {hasGameStarted ? `Closing Line: ${closingSpread}` : (
                            gameInfo?.homePointSpread ? `Line: ${closingSpread}` : 'Line: TBD'
                        )}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}

export default PickStatsCardSingle;